(ns dre.core
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.app.events :as app] 
   [dre.app.router :as router]
   [dre.app.views :as base]
   [dre.components.flash.events]
   [dre.components.privacy.utils :as privacy]
   [dre.components.search-results.events]
   [dre.components.widget.events]
   [dre.config :as-alias config]
   [dre.fx]
   [dre.i18n.events :as i18n]
   [dre.modals.events]
   [dre.network]
   [dre.pages.events]
   [dre.panels.events]
   [dre.processes.bootstrap]
   [dre.storage.events]
   [dre.sse :as sse]
   [dre.widgets.events]
   [re-frame.core :as rf]
   [reagent.dom :as dom]
   [superstructor.re-frame.fetch-fx]))


(defn render!
  []
  (dom/render
    [#'base/view]
    (js/document.getElementById "app")))


(defn reload!
  []
  (rf/clear-subscription-cache!)
  (render!))


(defn ^:export main
  []
  (rf/dispatch [::config/init]))


(rf/reg-fx
  ::render
  (fn [_ _]
    (render!)))


(rf/reg-event-fx
  ::render
  (fn-traced [_ _]
             {::render nil}))

;; Run initialization in multiple steps sync or with delay to make sure all required data are loaded before next step
(rf/reg-event-fx
 ::init-step-1
 (fn-traced [_ _]
            {:fx [[:dispatch [::i18n/init]]
                  [:dispatch [::app/init {:on-ok [::init-step-2]}]]
                  [:dispatch [::render]]]}))

(rf/reg-event-fx
 ::init-step-2
 (fn-traced [{db :db} _]
            (let [_ (sse/init! db) ;;!!!TODO rework -> init from auth data...dont make separate call
                  _ (privacy/load-analytics!)] 
              {:dispatch-later {:ms 1000
                                :dispatch [::init-step-3]}})))

(rf/reg-event-fx
  ::init-step-3
  (fn-traced [_ _]
             {:fx [[:dispatch [::router/init]]]}))
